import React from 'react'

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 72" fill="none" width="100%" height="100%" {...props}>
    <path d="M1440 72H0V53S231 0 524 0c279 0 621 100 916 53v19z" fill="currentColor" />
  </svg>
)